import React from "react";
import "../styles/RecommendedJobs.css";
import { RECOMMENDATION_STATUS } from "../Enums/enums";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export default function RecommendedJobs({ uploadedSkills = [], data, jobs }) {
  const jobData = [
    { title: "Frontend Developer", skills: ["React", "CSS", "HTML"] },
    { title: "Backend Developer", skills: ["Node.js", "Express", "MongoDB"] },
    { title: "DevOps Engineer", skills: ["Docker", "AWS"] },
    { title: "Full Stack Engineer", skills: ["React", "Node.js", "GraphQL"] },
  ];

  const matchedJobs = jobData.filter((job) =>
    job.skills.some((skill) => uploadedSkills.includes(skill))
  );

  function showStatus() {
    console.log("Data received:", data?.status);
    if (data) {
      return getStatusMessage(data.status);
    }
  }

  function getStatusMessage(status) {
    switch (status) {
      case RECOMMENDATION_STATUS.STARTED:
        return "Recommendations started successfully...";
      case RECOMMENDATION_STATUS.EXTRACTED_TEXT_FROM_RESUME:
        return "Extracting text from resume...";
      case RECOMMENDATION_STATUS.FETCHING_JOBS:
        return "Getting job listings...";
      case RECOMMENDATION_STATUS.JOBS_FETCHED:
        return "Job listings fetched successfully...";
      case RECOMMENDATION_STATUS.RECOMMENDATION_COMPLETED:
        return "Recommendations are ready!";
      case RECOMMENDATION_STATUS.RECOMMENDATION_FAILED:
        return "Failed to generate recommendations!!!";
      case RECOMMENDATION_STATUS.NOT_STARTED:
        return "Recommendations have not started yet!!!";
      case RECOMMENDATION_STATUS.EXTRACTED_TEXT_FAILED:
        return "Failed to extract text from resume!!!";
      case RECOMMENDATION_STATUS.CREATED_QUERY_FAILED:
        return "Failed to create query for job recommendations!!!";
      case RECOMMENDATION_STATUS.FETCHING_JOBS_FAILED:
        return "Failed to fetch job listings!!!";
      case RECOMMENDATION_STATUS.JOBS_FETCHED_FAILED:
        return "Failed to fetch job recommendations!!!";
      case RECOMMENDATION_STATUS.CREATED_QUERY:
        return "Query for job recommendations created successfully...";
      default:
        return "Unknown status.";
    }
  }

  return (
    <div className="jobs-container">
      <h2>Recommended Jobs</h2>
      {!jobs || jobs.length === 0 ? (
        <div className="no-jobs-message">
          <p>No job recommendations available.</p>
          {showStatus() && <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>}
          <p>{showStatus()}</p>
        </div>
      ) : (
        <ul className="job-list">
          {jobs.map((job, index) => (
            <li key={index} className="job-item">
              <h3>{job.title}</h3>
              <p>
                Company:{" "}
                {(() => {
                  try {
                    const company = JSON.parse(job.company_profile);
                    return (
                      <>
                        <strong>{company.Sector}</strong> | {company.Industry}
                        <br />
                        {company.City}, {company.State} {company.Zip}
                        <br />
                        Website:{" "}
                        <a
                          href={`https://${company.Website.replace(
                            /^https?:\/\//,
                            ""
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {company.Website}
                        </a>
                        <br />
                        Ticker: {company.Ticker}
                        <br />
                        CEO: {company.CEO}
                      </>
                    );
                  } catch {
                    return job.company_profile;
                  }
                })()}
              </p>
              <p>Skills: {job.skills_required.join(", ")}</p>
              <p>Location: {job.location}</p>
              <p>Contact: {job.contact}</p>
              <p>Contact Person: {job.contact_person}</p>
              <p>Salary: {job.salary_range}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
